module.exports = __webpack_public_path__ + "static/img/00072E_2_C_20210201_LC.e4a94a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/00072E_2_C_20210201_LC.png
// module id = b51I
// module chunks = 0